"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressDetails = void 0;
class AddressDetails {
}
exports.AddressDetails = AddressDetails;
//# sourceMappingURL=AddressDetails.js.map